var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7904 20.7723C10.5971 15.4875 14.7162 11.0426 20.0004 10.834C25.2846 11.0426 29.4038 15.4875 29.2104 20.7723C29.2104 22.9673 31.5954 25.1057 31.6654 27.3057C31.6654 27.3368 31.6654 27.3679 31.6654 27.399C31.7171 28.8085 30.6182 29.9939 29.2088 30.049H23.8888C23.8937 31.129 23.4866 32.1703 22.7504 32.9607C22.0426 33.7293 21.0454 34.1667 20.0004 34.1667C18.9555 34.1667 17.9583 33.7293 17.2504 32.9607C16.5143 32.1703 16.1072 31.129 16.1121 30.049H10.7904C9.38107 29.9939 8.28216 28.8085 8.33378 27.399C8.33378 27.3679 8.33378 27.3368 8.33378 27.3057C8.40544 25.1123 10.7904 22.969 10.7904 20.7723Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1133 29.0483C15.561 29.0483 15.1133 29.496 15.1133 30.0483C15.1133 30.6006 15.561 31.0483 16.1133 31.0483V29.0483ZM23.8899 31.0483C24.4422 31.0483 24.8899 30.6006 24.8899 30.0483C24.8899 29.496 24.4422 29.0483 23.8899 29.0483V31.0483ZM21.6683 8.5C22.2206 8.5 22.6683 8.05228 22.6683 7.5C22.6683 6.94772 22.2206 6.5 21.6683 6.5V8.5ZM18.3349 6.5C17.7827 6.5 17.3349 6.94772 17.3349 7.5C17.3349 8.05228 17.7827 8.5 18.3349 8.5V6.5ZM16.1133 31.0483H23.8899V29.0483H16.1133V31.0483ZM21.6683 6.5H18.3349V8.5H21.6683V6.5Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 7.5,
    r: 3.5,
    fill: "#E95C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.86923ba3d8ec7c7bd3b3c468dde1c012.svg";
export { ForwardRef as ReactComponent };